import { useMemo } from "react";

import { resolveAvailableBindableTargetsCreate } from "./querying/resolveAvailableBindableTargets.ts";
import { useResolveAvailableValues } from "./useResolveAvailableValues.ts";
import { useResolveDesignTimeValue } from "./useResolveDesignTimeValue.ts";

export const useResolveAvailableBindableTargets = () => {
  const resolveAvailableValues = useResolveAvailableValues();
  const resolveDesignTimeValue = useResolveDesignTimeValue();
  return useMemo(
    () => resolveAvailableBindableTargetsCreate({ resolveAvailableValues, resolveDesignTimeValue }),
    [resolveAvailableValues, resolveDesignTimeValue],
  );
};
